<template>
    
    <div class="container">
        <div class="row col-12 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">درباره ما</h2>
            <h5 class="mt-4">ناباکو چیست و چگونه کار می‌کند؟</h5>
            <h5 class="mt-3">
                شرکت هوش مصنوعی مالی ناباکو به عنوان یکی از شرکت های پیشرو کشور در جهت استفاده از مدل های هوش مصنوعی و هوش ریاضی در  صنعت مالی کشور فعالیت خود را در سال 1400 آغاز کرد .
                <br>
                هوش مصنوعی ناباکو با انجام پروژه های مختلف در صنایع مالی و همکاری در تعالی و پیشرفت استفاده واقعی از هوش مصنوعی به عنوان یک ابزار کاربردی در صنعت مالی در سطح بین المللی نیز فعالیت داشته و با کشور های حاشیه حوزه خلیج فارس اروپا و امریکای شمالی همکاری های فراوانی داشته است.
                <br>
                <br>
                استفاده از ابزار هوش مصنوعی به عنوان یک پیشی بینی کننده با ضرایب دقیق و بالا و خوانش دیتای بسیار بالا و قدرت پردازش پیشرفته هوش ریاضی کمک زیادی درراه رسیدن به موفقیت های مالی به سرمایه گذاران خود داشته است.
            </h5>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <div class="col-lg-4 text-end pt-5">
                        <h2 class="fw-bold">ماموریت ما</h2>
                        <h5 class="mt-3">
                            هوش مصنوعی ناباکو در حال حاضر استفاده از هوش مصنوعی را برای کاربران خود میسر کرده است و سرمایه گذاران می توانند از این ابزار به عنوان دستیار مناسب سرمایه گذاری استفاده نمایند. ماموریت ما در هوش مصنوعی ناباکو استفاده از  هوش مصنوعی قابل توصیف در در صنعت مالی کشور می باشد که می تواند جهش عظیمی  را در این صنعت دانست .
                        </h5>
                    </div>
                    <div class="col-lg-6 my-auto text-start">
                        <img src="../assets/test/mission.svg" class="w-75" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <div class="col-lg-4 my-auto text-end">
                        <img src="../assets/services-img/img16.svg" class="w-75" alt="">
                    </div>
                    <div class="col-lg-6 text-end pt-5">
                        <h2 class="fw-bold">چشم انداز</h2>
                        <h5 class="mt-3">
                            هوش مصنوعی ناباکو به عنوان یکی از شرکت های پیشرو در زمینه استفاده صحیح از مدل ها والگو ریتم های ریاضی و هوش مصنوعی کاربردی در صنایع تمامی تلاش خود را در جهت بهینه سازی الگوریتم های خود می نماید تا سرمایه گذاران با راحتی و اطمینان بالا به سود حداکثری رسیده و امنیت سرمایه گذاری را تجربه نمایند.
                        </h5>
                    </div>
                </div>
            </div>
            <div class="row col-md-9 mx-auto">
                <div class="col-md-6">
                    <div>
                        <img src="../../public/img/HosseinMalekinezhad.png" width="100%" alt="">
                    </div>
                </div>
                <div class="col-md-6 my-auto">
                    <div class="text-end px-5">
                        <h3>دکتر حسین مالکی نژاد</h3>
                        <h5>رئیس هیئت مدیره</h5>
                        <h5>سابقه فعالیت مدیر تکنولوژی فناوری های بانکی</h5>
                        <h5>دکترای هوش مصنوعی و یادگیری ماشین</h5>
                        <h5>راه اندازی سیستم های های پیش بینی در صنعت مالی </h5>
                    </div>
                </div>
                
                <div class="col-md-6 my-auto">
                    <div class="text-end px-5">
                        <h3>حسین موذن</h3>
                        <h5>مدیرعامل</h5>
                        <h5>کارشناسی ارشد مدیریت استراتژی</h5>
                        <h5>سابقه فعالیت راه اندازی سیستم های هوشمند در صنعت نفت و گاز و پتروشیمی</h5>
                        <h5>مشاوره  و راه اندازی  سیستم های مبتنی بر هوش مصنوعی و اینترنت اشیا</h5>
                        <h5>راه اندازی کسب و کارهای نوپا در ایران و شمال امریکا </h5>
                    </div>
                </div>
                <div class="col-md-6">
                    <div>
                        <img src="../../public/img/HoseinMoazen.png" width="100%" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>